import { Box, styled, Theme, Typography } from '@mui/material';
import { palette } from 'view/themes/palette';

export const CandidateProfileBlock = styled(Box)<{ isJobSeeker: any }>(({
  theme,
  isJobSeeker,
}: {
  theme: Theme;
  isJobSeeker: any;
}) => {
  return {
    width: isJobSeeker ? '100%' : 'calc(100% - 370px - 24px)', // gap = 24px, menuWidth = 270px
    minHeight: 'calc(100vh - 250px)',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: palette.white,
    borderRadius: '24px',
    padding: '24px', // need to be 32px

    [theme.breakpoints.down('laptop')]: {
      width: '100%',
    },

    [theme.breakpoints.down('tablet')]: {
      minHeight: 'calc(100vh - 136px)',
      width: '100%',
      gap: '4px',
      padding: '8px 0 0 0',
    },
  };
});

export const CandidateProfileBlockHeader = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    width: '100%',
    height: 'max-content',
    /* backgroundColor: 'red', */
  };
});

export const QualificationsContainer = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    display: 'grid',
    padding: '32px 0 32px 0',
    gridTemplateColumns: '1fr 2fr',
    gap: '16px',
    alignItems: 'stretch',
    borderBottom: '1px solid #D8DBE8',

    [theme.breakpoints.down('desktop')]: {
      gridTemplateColumns: '1fr',
    },
  };
}) as typeof Box;

export const QualificationsTitle = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    color: palette.text.header,
    fontWeight: 700,
    fontSize: '32px',
    lineHeight: '38px',
    whiteSpace: 'pre-wrap',
  };
}) as typeof Box;

export const QualificationsContent = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    display: 'flex',
    flexDirection: 'column',
    gap: '32px',
  };
}) as typeof Box;

export const ReusableTextBlock = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  };
}) as typeof Box;

export const ReusableTextBlockTitle = styled(Typography)(({ theme }: { theme: Theme }) => {
  return {
    color: palette.text.header,
    fontWeight: 700,
    fontSize: '24px',
    lineHeight: '31px',
  };
}) as typeof Typography;

export const ReusableTextBlockDesc = styled(Typography)(({ theme }: { theme: Theme }) => {
  return {
    width: 'max-content',
    color: palette.text.header,
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '136%',
    padding: '12px 16px',
    borderRadius: '24px',
    backgroundColor: '#EDF1FF',
  };
}) as typeof Typography;

export const ReusableTextBlockContent = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '3px',
  };
}) as typeof Box;

export const WorkExperienceContent = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    backgroundColor: '#F3F9EE',
    borderRadius: '24px',
    padding: '20px',
  };
}) as typeof Box;

export const CoverLetterContent = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    backgroundColor: '#FFEFC7',
    borderRadius: '12px',
    padding: '16px',
  };
}) as typeof Box;

export const WorkExperienceContentItem = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    display: 'flex',
    gap: '16px',

    '> svg': {
      flexShrink: 0,
    },
  };
}) as typeof Box;

export const CoverLetterContentItem = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',

    '> svg': {
      flexShrink: 0,
    },
  };
}) as typeof Box;

export const WorkExperienceContentItemTitle = styled(Typography)(({ theme }: { theme: Theme }) => {
  return {
    color: palette.text.header,
    fontWeight: 700,
    fontSize: '16px',
    lineHeight: '130%',
  };
}) as typeof Typography;

export const WorkExperienceContentItemProfession = styled(Typography)(
  ({ theme }: { theme: Theme }) => {
    return {
      color: palette.text.header,
      fontWeight: 400,
      fontSize: '12px',
      lineHeight: '136%',
    };
  }
) as typeof Typography;

export const WorkExperienceContentItemDate = styled(Typography)(({ theme }: { theme: Theme }) => {
  return {
    color: '#857F8B',
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '136%',
  };
}) as typeof Typography;

export const WorkExperienceContentItemLink = styled(Typography)(({ theme }: { theme: Theme }) => {
  return {
    display: 'flex',
    alignItems: 'center',
    gap: '5px',
    color: palette.primary.purple500,
    fontWeight: 600,
    fontSize: '12px',
    lineHeight: '150%',
    cursor: 'pointer',
  };
}) as typeof Typography;

export const WorkExperienceContentItemDesc = styled(Typography)(({ theme }: { theme: Theme }) => {
  return {
    color: palette.text.body,
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '136%',
    whiteSpace: 'break-spaces',
    margin: '10px 0 0 0',
  };
}) as typeof Typography;

export const Footer = styled(Box)({
  display: 'flex',
  flexWrap: 'wrap',
  gap: '24px',
  backgroundColor: palette.background.general,
  padding: '32px',
  borderRadius: '24px',
  marginTop: '40px',
}) as typeof Box;

export const CandidateContactCardMainItem = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',

    '> p': {
      color: palette.text.body,
      fontWeight: 400,
      fontSize: '16px',
      lineHeight: '136%',
    },
  };
});
